import { TranslatableError } from "../types/TranslatableError";
import ErrorCodes from "../config/ErrorCodes";

export function formatFormErrors(
  errors?: FormErrors,
  defaultGlobalError?: string
): FormattedFormErrors {
  console.error("form errors", errors);
  const fieldErrors = errors?.fieldErrors || {};
  return {
    ...fieldErrors,
    globalError:
      errors?.globalError ||
      (Object.keys(fieldErrors).length > 0
        ? ErrorCodes.FORM_CONTAINS_ERRORS
        : defaultGlobalError || ErrorCodes.UNKNOWN)
  };
}

export function isTranslatableError(
  error: unknown
): error is TranslatableError {
  return !!error && typeof error === "object" && "code" in error;
}
